<template>
    <ProduzioneInsit :is_insit="false" />
</template>
<script>
import ProduzioneInsit from "@/views/PRODUCTION/ProduzioneInsit/ProduzioneInsit.vue";

export default {
  name: "",
  components: { ProduzioneInsit },
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {

  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>